import {eventSlots,eventTagLabel,parseSetupKey,resolveSetupEvent} from './eventSetup';
import {legacyLineup} from './matchLineup';

export function reviewCardMetadata({records=[],match={},events=[]}) {
 const first=records[0]||{};
 const key=match.calendarEventId||records.find(record=>record.calendarEventId)?.calendarEventId||'';
 const event=resolveSetupEvent(events,key);
 const slot=event ? eventSlots(event).find(item=>item.id===(parseSetupKey(key)?.slotId||'map-1')) : null;
 const lineup=slot&&Array.isArray(slot.lineup) ? slot.lineup : legacyLineup([match,...records].find(record=>record.players?.length||record.comp?.length)||{});
 const savedTag=match.calendarEventTag||first.calendarEventTag||match.tag||first.tag;
 const tag=event ? eventTagLabel(event) : savedTag ? eventTagLabel({tag:savedTag,scrimType:match.scrimType||first.scrimType}) : [...new Set(records.flatMap(record=>record.tags||record.selectedTags||[]))].join(' · ');
 const sizes=records.map(record=>record.sizeBytes).filter(value=>value!=null&&value!==''&&Number.isFinite(Number(value))&&Number(value)>=0).map(Number);
 return {lineup,tag:tag||'Not assigned',date:event?.startUTC||match.calendarEventStartUTC||first.calendarEventStartUTC||match.matchPlayedAt||first.matchPlayedAt||first.createdAt||null,sizeBytes:sizes.length?sizes.reduce((sum,size)=>sum+size,0):null};
}
export function formatReviewCardDate(value) {
 const date=value?.toDate?value.toDate():value?.seconds!=null?new Date(value.seconds*1000):value?new Date(value):null;
 if(!date||!Number.isFinite(+date))return 'Not set';
 return [String(date.getDate()).padStart(2,'0'),date.toLocaleString('en-US',{month:'short'}),date.getFullYear()].join('/');
}
export function formatReviewCardSize(bytes) {
 if(bytes==null)return 'Unavailable';
 return bytes>=1024**3 ? (bytes/1024**3).toFixed(2)+' GB' : (bytes/1024**2).toFixed(2)+' MB';
}
